import { SVGProps, Ref, forwardRef } from 'react';

export const ShareWebFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M7.226 13.763c-.267-.264-.407-.691-.48-1.34a15 15 0 0 1-.073-1.399 9 9 0 0 0-1.396.227c-1.76.423-3.28 1.292-4.253 1.952-.468.318-1.107-.001-1.015-.56.347-2.125 1.668-6.01 6.658-7.176.012-1.8.088-2.768.56-3.234.561-.555 1.35-.067 2.93.909l2.27 1.403c2.38 1.47 3.569 2.206 3.569 3.453s-1.19 1.983-3.57 3.453l-2.27 1.403c-1.578.976-2.368 1.464-2.93.91"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ShareWebFilledSize16Glyph.displayName = 'ShareWebFilledSize16Glyph';
